import React from 'react';
import {Bar} from './style';

function Stats(props) {
  return <Bar {...props} />;
}

export default Stats;
